import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

/**
 * Root shell for the customer portal — a bare router host. Auth gating
 * + the post-login dashboard live in `app.routes.ts`.
 */
@Component({
  selector: 'prtl-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class AppComponent {}
